import React from 'react';

import FaChevronLeft from 'react-icons/lib/fa/chevron-left';

import { Link, ProgressBar } from 'wanderu-components';

import styles from './Stepper.scss';

interface NavProps {
    BackLink?: React.ComponentType<{ children: React.ReactNode, className: string }>;
    backText?: string;
    decrementStep: (e?: React.MouseEvent) => void;
    goToStep: (step: string) => void;
    step: string;
    steps: string[];
}

export const Nav = ({
    BackLink,
    backText,
    decrementStep,
    goToStep,
    step,
    steps,
}: NavProps) => {
    const isFirst = steps[0] === step;
    const linkStyles = { root: styles.link };
    const content = <><FaChevronLeft /> {backText}</>;

    return (
        <div className={styles.nav}>
            {isFirst
                ? (BackLink && <BackLink className={styles.link}>{content}</BackLink>)
                : <Link classes={linkStyles} href="#" onClick={decrementStep} tabIndex={0}>{content}</Link>
            }
            <ProgressBar goToStep={goToStep} steps={steps} value={step} />
        </div>
    );
};
